import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetPlayInformationMutationVariables = Types.Exact<{
	input: Types.GetPlayInformationInput;
}>;

export type GetPlayInformationMutation = {
	__typename?: 'Mutation';
	getPlayInformation: {
		__typename: 'GetPlayInformationPayload';
		streams?: Array<{
			__typename?: 'Stream';
			url: string;
			encodingType: string;
			drmURLs?: Array<{ __typename?: 'DrmURL'; laURL: string; drmType: Types.DrmType }> | null;
		}> | null;
	};
};

export const GetPlayInformationDocument = gql`
	mutation GetPlayInformation($input: GetPlayInformationInput!) {
		getPlayInformation(input: $input) {
			streams {
				url
				drmURLs {
					laURL
					drmType
				}
				encodingType
			}
			__typename
		}
	}
`;
